const dev = {
  clientId: 'b96a3890-617c-45f3-81f9-0cc2e6b6e11b',
  OPServer:
    'https://microstrategyb2cdev.b2clogin.com/microstrategyb2cdev.onmicrosoft.com/b2c_1A_signinhrd/v2.0/',
  redirectURL: 'http://localhost:3000/authentication/callback',
  postLogoutRedirectUri: 'http://localhost:3000',
  scope: 'openid https://microstrategyb2cdev.onmicrosoft.com/SPNameV1/read',
  authorizationEndpoint:
    'https://microstrategyb2cdev.b2clogin.com/microstrategyb2cdev.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/authorize',
  endSessionEndpoint:
    'https://microstrategyb2cdev.b2clogin.com/microstrategyb2cdev.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/logout',
  tokenEndpoint:
    'https://microstrategyb2cdev.b2clogin.com/microstrategyb2cdev.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/token',
  // You can set `requireAuth` to false to disable the login workflow for the Playground.
  requireAuth: false,
};

const internalProd = {
  clientId: '949757dd-f242-42c5-9e0e-ec215329aa63',
  OPServer:
    'https://microstrategyb2c.b2clogin.com/microstrategyb2c.onmicrosoft.com/b2c_1A_signinhrd/v2.0/',
  redirectURL: 'https://legendary-bassoon-493pgwo.pages.github.io/authentication/callback',
  postLogoutRedirectUri: 'https://legendary-bassoon-493pgwo.pages.github.io/',
  scope: 'openid https://identity.microstrategy.com/c625c19a-deac-4607-9979-365a328955a5/read',
  authorizationEndpoint:
    'https://microstrategyb2c.b2clogin.com/microstrategyb2c.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/authorize',
  endSessionEndpoint:
    'https://microstrategyb2c.b2clogin.com/microstrategyb2c.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/logout',
  tokenEndpoint:
    'https://microstrategyb2c.b2clogin.com/microstrategyb2c.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/token',
  // You can set `requireAuth` to false to disable the login workflow for the Playground.
  requireAuth: true,
};

const publicProd = {
  clientId: '949757dd-f242-42c5-9e0e-ec215329aa63',
  OPServer:
    'https://identity.microstrategy.com/microstrategyb2c.onmicrosoft.com/b2c_1A_signinhrd/v2.0/',
  redirectURL: 'https://microstrategy.github.io/playground/authentication/callback',
  postLogoutRedirectUri: 'https://microstrategy.github.io/playground',
  scope: 'openid https://identity.microstrategy.com/c625c19a-deac-4607-9979-365a328955a5/read',
  authorizationEndpoint:
    'https://identity.microstrategy.com/microstrategyb2c.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/authorize',
  endSessionEndpoint:
    'https://identity.microstrategy.com/microstrategyb2c.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/logout',
  tokenEndpoint:
    'https://identity.microstrategy.com/microstrategyb2c.onmicrosoft.com/b2c_1a_signinhrd/oauth2/v2.0/token',
  // You can set `requireAuth` to false to disable the login workflow for the Playground.
  requireAuth: true,
};

let config = dev;
switch (process.env.REACT_APP_STAGE) {
  case 'public-prod':
    config = publicProd;
    break;
  case 'internal-prod':
    config = internalProd;
    break;
  default:
    config = dev;
}

const exportedConfig = config;

export default exportedConfig;
